import { render, staticRenderFns } from "./UserPersonalInfoEditDialog.vue?vue&type=template&id=b65df4fc&"
import script from "./UserPersonalInfoEditDialog.vue?vue&type=script&lang=js&"
export * from "./UserPersonalInfoEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports